"use client";

import { useEffect } from "react";
import { LinkButton } from "@/components/ui/LinkButton";
import { Button } from "@/components/ui/Button";

interface ErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function Error({ error, reset }: ErrorProps) {
  useEffect(() => {
    if (process.env.NODE_ENV === "development") {
      console.error(error);
    }
  }, [error]);

  return (
    <div className="mt-16 flex min-h-[60vh] flex-col items-center justify-center px-4 py-16 text-center">
      <p className="mb-4 text-6xl font-bold text-primary">!</p>
      <h1 className="mb-2 text-2xl font-bold text-foreground">
        Something went wrong
      </h1>
      <p className="mb-8 max-w-md text-muted">
        We encountered an unexpected error. Please try again or return to the
        homepage.
      </p>
      <div className="flex flex-col gap-3 sm:flex-row">
        <Button variant="accent" onClick={reset}>
          Try again
        </Button>
        <LinkButton href="/" variant="outline">
          Back to Home
        </LinkButton>
      </div>
    </div>
  );
}
